/**
 * Constants for Thesys C1Chat feature.
 */

export const THESYS_CHAT_DEFAULT_API_URL = '/api/xai-chat';
export const THESYS_CHAT_DEFAULT_THREAD_ID = 'default-thread';
